import { render, staticRenderFns } from "./CreationContain.vue?vue&type=template&id=0f9dd542&scoped=true&"
import script from "./CreationContain.vue?vue&type=script&lang=js&"
export * from "./CreationContain.vue?vue&type=script&lang=js&"
import style0 from "./CreationContain.vue?vue&type=style&index=0&id=0f9dd542&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f9dd542",
  null
  
)

export default component.exports